<template>
    <information-content @redirect='redirectLogin'>
        <template slot='title'>
            Votre inscription a bien été prise en compte.<br>
            Un email de confirmation vous a été envoyé.
        </template>
        <template slot='label'>
            SE CONNECTER
        </template>
    </information-content>
</template>
<script>
    import InformationContent from '../components/layout/InformationContent';

    export default {
        components: {
            InformationContent},
        name: 'register-success',
        methods: {
            redirectLogin: function (event) {
                this.$router.push({name: 'login'});
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/RegisterSuccess.vue